var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.label)?_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.label)+" : ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }